/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MondayStatusChangeProjectMilestoneRequestPayloadInputFields } from './MondayStatusChangeProjectMilestoneRequestPayloadInputFields';
import {
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSON,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSONTyped,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsToJSON,
} from './MondayStatusChangeProjectMilestoneRequestPayloadInputFields';

/**
 * 
 * @export
 * @interface MondayStatusChangeProjectMilestoneRequestPayload
 */
export interface MondayStatusChangeProjectMilestoneRequestPayload {
    /**
     * 
     * @type {MondayStatusChangeProjectMilestoneRequestPayloadInputFields}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayload
     */
    inputFields: MondayStatusChangeProjectMilestoneRequestPayloadInputFields;
}

/**
 * Check if a given object implements the MondayStatusChangeProjectMilestoneRequestPayload interface.
 */
export function instanceOfMondayStatusChangeProjectMilestoneRequestPayload(value: object): value is MondayStatusChangeProjectMilestoneRequestPayload {
    if (!('inputFields' in value) || value['inputFields'] === undefined) return false;
    return true;
}

export function MondayStatusChangeProjectMilestoneRequestPayloadFromJSON(json: any): MondayStatusChangeProjectMilestoneRequestPayload {
    return MondayStatusChangeProjectMilestoneRequestPayloadFromJSONTyped(json, false);
}

export function MondayStatusChangeProjectMilestoneRequestPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): MondayStatusChangeProjectMilestoneRequestPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'inputFields': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSON(json['inputFields']),
    };
}

export function MondayStatusChangeProjectMilestoneRequestPayloadToJSON(value?: MondayStatusChangeProjectMilestoneRequestPayload | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'inputFields': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsToJSON(value['inputFields']),
    };
}

